export enum WebISSStatusEnum {

  Ativo = "Ativo",
  Bloqueado = "Bloqueado",
  ParalisadoTemporariamente = "Paralisado (temporariamente)",
  ParalisadoRevelia = "Paralisado (revelia)",
  SobFiscalizacao = "Sob fiscalização"
}
